import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PublicLinkPasswordService {
  private passwords: Map<string, string> = new Map();

  setPassword(publicId: string, password: string): void {
    this.passwords.set(publicId, password);
  }

  getPassword(publicId: string): string | undefined {
    return this.passwords.get(publicId);
  }

  clearAll(): void {
    this.passwords.clear();
  }

  hasPassword(publicId: string): boolean {
    return this.passwords.has(publicId);
  }
}
